module.exports = __webpack_public_path__ + "static/incorporation-84e2892af7bc4b1c2bb624d0e751dcdd.jpg";